import {
  deleteCookie,
  getCookie,
  setCookie
} from '../services/cookieController';

export const KEY_SESSION = process.env.REACT_APP_KEY_SESSION as string;
export const KEY_REFRESH_SESSION = process.env
  .REACT_APP_KEY_REFRESH_SESSION as string;

// const authOptions: CookieAttributes = {
//   domain: getCurrentDomain(),
//   sameSite: 'none',
//   secure: true
// };

export function getTokenSession() {
  const token: any = getCookie(KEY_SESSION);
  return token;
}

export function setTokenSession(token: string) {
  setCookie(KEY_SESSION, token);
}

export function deleteTokenSession() {
  deleteCookie(KEY_SESSION);
}

export function getRefreshTokenSession() {
  const refreshToken: any = getCookie(KEY_REFRESH_SESSION);
  return refreshToken;
}

export function setRefreshTokenSession(token: string) {
  setCookie(KEY_REFRESH_SESSION, token);
}

export function deleteRefreshTokenSession() {
  deleteCookie(KEY_REFRESH_SESSION);
}
